import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirm-close-modal',
  templateUrl: './confirm-close-modal.component.html',
  styleUrl: './confirm-close-modal.component.scss'
})
export class ConfirmCloseModalComponent {
  /**
  * Constructor
  * @param modalService 
  */
  constructor(
    private modalService: NgbActiveModal
  ) {
  }

  closeModel() {
    this.modalService.close("cancelled")
  }

  confirmClose() {
    this.modalService.close('confirmed')
  }
}
